var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenCardDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "rotate(-90 24 24)",
    fill: "#89939E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1218 10.5653C25.9409 10.3844 25.6908 10.2722 25.4147 10.2725H22.5863C22.0333 10.2725 21.5857 10.7201 21.5864 11.2724L21.5864 21.5862L11.2726 21.5862C10.7196 21.5862 10.272 22.0339 10.2727 22.5861V25.4145C10.2727 25.9675 10.7203 26.4151 11.2726 26.4144L21.5864 26.4144V36.7282C21.5857 37.2805 22.034 37.7288 22.5863 37.7281H25.4147C25.9677 37.7281 26.4153 37.2805 26.4146 36.7282V26.4144L36.7284 26.4144C37.2807 26.4151 37.729 25.9668 37.7283 25.4145V22.5861C37.7283 22.0331 37.2807 21.5855 36.7284 21.5862L26.4146 21.5862L26.4146 11.2724C26.4146 10.9959 26.3027 10.7462 26.1218 10.5653Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCardDetailsIcon);
export default __webpack_public_path__ + "static/media/open-card-details-icon.8b5625b57b3dbb4a2a819c3c0fa1c34f.svg";
export { ForwardRef as ReactComponent };